'use client'

import { Fragment, ReactNode, useEffect, useState } from 'react'

import { Container } from '../../components/container'
import { useBreakpoints } from '../../hooks/use-breakpoints'
import { cn } from '../../utils/cn'

export const BaseCMSGrid = ({
  elements,
  numberOfColumns,
  showOverlap,
}: {
  elements: ReactNode[]
  numberOfColumns: number
  showOverlap?: boolean
}) => {
  const breakpoints = useBreakpoints()
  const [cols, setCols] = useState(numberOfColumns)

  useEffect(() => {
    if (breakpoints.isDesktop) {
      setCols(numberOfColumns)
    } else if (breakpoints.isTablet) {
      setCols(numberOfColumns > 2 ? 2 : numberOfColumns)
    } else {
      setCols(1)
    }
  }, [breakpoints])

  return (
    <Container className={cn('my-6')}>
      <div
        className={cn(
          showOverlap && 'lg:border lg:border-neutral-300 lg:py-9 lg:bg-white',
          showOverlap && elements.length === 3 && 'max-w-[62rem] mx-auto'
        )}
      >
        <div
          className={cn(
            'grid gap-10',
            showOverlap && 'lg:gap-0 lg:divide-x lg:divide-neutral-300'
          )}
          style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}
          data-testid="grid"
        >
          {elements.map((x, i) => (
            <div key={i}>{x}</div>
          ))}
        </div>
      </div>
    </Container>
  )
}
